import React, { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";
import DragDropFile from "./DragDropFile";
import DataInput from "./DataInput";
import { Alert, AlertTitle } from "@mui/material";
import {
  Typography,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

const AddUser1 = (props) => {
  const [question, setQuestion] = useState({
    data: [],
    sheetname: [],
    questionFile: {},
    errorMessage: "",
  });

  const [fileData, setFileData] = useState({});
  const [validationerror, setvalidationError] = React.useState(false);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };



  const handleClose = () => {
    setOpen(false);
    setQuestion({ data: "" });
    setFileErrorMessage("");
    setQuestion((prevState) => ({
      ...prevState,
      errorMessage: "",
      data: null
    }));
    setvalidationError(false);
    //window.location.reload();
  };

  const [fileErrorMessage, setFileErrorMessage] = useState('');

  const handleSubmitClick = (e) => {
    if (question.data.length === 0) {
      setFileErrorMessage('Please select your excel file to upload questions');
      return;
    }
    const data = {
      // sheetname: question.sheetname,
      questions: question.data,
      // file: question.questionFile
    }
    props.setSubmitQuestions({ data: question.data });
    setOpen(false);
  };

  const fileType = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

  const handleFile = (file) => {
    if (file && fileType.includes(file.type)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });

        const jsonArr = [];
        let numQuestions = 0;
        let isValidFile = true;
        wb.SheetNames.forEach(sheet => {
          const ws = wb.Sheets[sheet];
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          const questionArr = [];

          if (data.length < 0 && data.length > 31) {
            isValidFile = false;
          }
          if (isValidFile) {
            for (let i = 0; i < data.length; i++) {
              const row = data[i];
              const data_type = row[0] ? row[0].toString().trim() : '';
              if (data_type === 'Multiple Choice') {
                if (row.length !== 7) {
                  isValidFile = false;
                  break;
                }
              } else if (data_type === 'Boolean' || data_type === 'Bolean') {
                if (row.length !== 5) {
                  isValidFile = false;
                  break;
                }
              } else {
                isValidFile = false;
                break;
              }
            }
          }
          if (isValidFile) {
            for (let i = 0; i < data.length; i++) {
              const row = data[i];
              const data_type = row[0] ? row[0].toString().trim() : '';
              const [type, question, answer, option1, option2, option3, option4] = data[i];
              const [type1, question1, answer1, option5, option6,] = data[i];
              if (data_type === 'Multiple Choice' && question && answer && option1 && option2 && option3 && option4) {
                if (typeof (question) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (answer) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option1) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option2) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option3) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option4) === 'undefined') {
                  isValidFile = false;
                }
                if (data[i] === '') {
                  isValidFile = false;
                }
                if (isValidFile === true) {
                  questionArr.push({
                    Type: type.toString(),
                    Question: question.toString(),
                    Answer: answer.toString(),
                    Option1: option1.toString(),
                    Option2: option2.toString(),
                    Option3: option3 ? option3.toString() : null,
                    Option4: option4 ? option4.toString() : null,
                  });
                  numQuestions++;
                }
              }
              else if (data_type === 'Boolean' || data_type === 'Bolean') {
                if (typeof (question1) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (answer1) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option5) === 'undefined') {
                  isValidFile = false;
                }
                if (typeof (option6) === 'undefined') {
                  isValidFile = false;
                }
                if (data[i] === '') {
                  isValidFile = false;
                }
                if (isValidFile === true) {
                  questionArr.push({
                    Type: type.toString(),
                    Question: question.toString(),
                    Answer: answer.toString(),
                    Option1: option1.toString(),
                    Option2: option2.toString(),
                    Option3: option3 ? option3.toString() : null,
                    Option4: option4 ? option4.toString() : null,
                  });
                  numQuestions++;
                }
              } else {
                isValidFile = false;
              }
            }
          }
          jsonArr.push(...questionArr);
        });
        if (!isValidFile || numQuestions < 1) {
          setvalidationError(true);
          setQuestion((prevState) => ({
            ...prevState,
            errorMessage: "Please refer to the sample questionnaire and upload valid Assessment file",
            data: null
          }));
        } else if (numQuestions > 50) {
          setvalidationError(true);
          setQuestion((prevState) => ({
            ...prevState,
            errorMessage: "Maximum 50 questions can be uploaded",
            data: null
          }));
        } else {
          setQuestion({ data: jsonArr });
          setvalidationError(false);
        }
      };

      reader.readAsBinaryString(file);
    } else {
      setvalidationError(true);
      setQuestion((prevState) => ({
        ...prevState,
        errorMessage: "Please select only excel file types",
        data: null
      }));
    }
  };

  useEffect(() => {
    //console.log(question);
  }, [fileData])

  useEffect(() => {
    setFileErrorMessage("");
  }, [question])

  return (
    <>
      <Tooltip title="Upload Questions" arrow>
        <Button
          variant="contained"
          // style={{ marginLeft: "20px" }}
          onClick={handleClickOpen}
          startIcon={<CloudUploadIcon />}
          sx={{ borderRadius: '50px', px: 3, py: 1 }}
          aria-label="Upload Questions"
        >
          Upload
        </Button>
      </Tooltip>
      <div className="App">
        <Dialog
          fullWidth
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          {validationerror ? (
            <Alert severity="error">
              <AlertTitle>Error </AlertTitle>
              {question.errorMessage}
            </Alert>
          ) : (
            ""
          )}
          <DialogTitle id="form-dialog-title">
            Example: User.csv, User.xlsx, User.xls
          </DialogTitle>

          <DialogContent>
            <DragDropFile setFileData={setFileData} handleFile={handleFile}>
              <div className="row">
                <div className="col-xs-12">
                  <DataInput setFileData={setFileData} handleFile={handleFile} />
                  {fileErrorMessage && <Typography color="error" style={{ marginLeft: "125px", marginTop: "10px", fontSize: "13px", lineHeight: "1.2" }}>{fileErrorMessage}</Typography>}
                </div>
              </div>
              <br />
            </DragDropFile>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cancel" arrow>
              <Button onClick={handleClose} color="primary" variant="contained" sx={{ borderRadius: '50px', px: 3, py: 1 }} aria-label="Cancel">
                Cancel
              </Button>
            </Tooltip>

            <Tooltip title="Upload" arrow>
              <span>
                <Button
                  onClick={handleSubmitClick}
                  color="primary"
                  variant="contained"
                  disabled={validationerror || !question.data}
                  sx={{ borderRadius: '50px', px: 3, py: 1 }}
                  aria-label="Upload"
                >
                  Ok
                </Button>
              </span>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default AddUser1;
